import type { VpcWithType } from "@/modules/network/vpc/vpcApi.ts";

export function getDefaultVpc<T extends Pick<VpcWithType, "is_default">>(items: readonly T[]) {
    return items.find((s) => s.is_default);
}
